(function(){
  if (window.__cwcaBound) return;
  window.__cwcaBound = true;
  var root = document.getElementById('wpWrap');
  if (!root) return;

  function toast(msg){
    var el = document.getElementById('wpToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wpToast';
      el.className = 'wp-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(function(){ el.classList.remove('is-on'); }, 2800);
  }

  var header = document.getElementById('wpHeader');
  if (header) {
    window.addEventListener('scroll', function(){
      header.classList.toggle('is-stuck', window.scrollY > 8);
    }, { passive: true });
  }

  var overlay = document.getElementById('wpNavOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'wpNavOverlay';
    overlay.className = 'wp-nav-overlay';
    root.appendChild(overlay);
  }

  var burger = document.getElementById('wpBurger');
  var nav = document.getElementById('wpNav');
  function closeNav(){
    if (nav) nav.classList.remove('is-open');
    Array.prototype.forEach.call(root.querySelectorAll('.wp-drop.is-open'), function(drop){
      drop.classList.remove('is-open');
      var toggle = drop.querySelector('.wp-drop-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    if (burger) {
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
    }
    overlay.classList.remove('is-on');
    document.body.classList.remove('wp-lock');
  }
  function openNav(){
    if (nav) nav.classList.add('is-open');
    if (burger) {
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
    }
    overlay.classList.add('is-on');
    document.body.classList.add('wp-lock');
  }
  if (burger && nav) {
    burger.setAttribute('aria-expanded', 'false');
    burger.addEventListener('click', function(){
      if (nav.classList.contains('is-open')) closeNav();
      else openNav();
    });
  }
  overlay.addEventListener('click', closeNav);

  Array.prototype.forEach.call(root.querySelectorAll('.wp-drop-toggle'), function(toggle){
    toggle.addEventListener('click', function(){
      var drop = toggle.closest('.wp-drop');
      if (!drop) return;
      var willOpen = !drop.classList.contains('is-open');
      Array.prototype.forEach.call(root.querySelectorAll('.wp-drop.is-open'), function(openDrop){
        if (openDrop !== drop) {
          openDrop.classList.remove('is-open');
          var openToggle = openDrop.querySelector('.wp-drop-toggle');
          if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        }
      });
      drop.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  var search = document.getElementById('wpSearch');
  var searchBtn = document.getElementById('wpSearchBtn');
  var searchInput = document.getElementById('wpSearchInput');
  var searchHits = document.getElementById('wpSearchHits');
  var searchEmpty = document.getElementById('wpSearchEmpty');
  function openSearch(){
    if (!search) return;
    closeNav();
    search.classList.add('is-on');
    document.body.classList.add('wp-lock');
    if (searchInput) setTimeout(function(){ searchInput.focus(); }, 30);
  }
  function closeSearch(){
    if (!search) return;
    search.classList.remove('is-on');
    document.body.classList.remove('wp-lock');
  }
  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (search) {
    search.addEventListener('click', function(e){
      if (e.target === search) closeSearch();
    });
  }
  var searchClose = document.getElementById('wpSearchClose');
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  function filterSearch(){
    if (!searchHits) return;
    var q = (searchInput && searchInput.value || '').toLowerCase().trim();
    var n = 0;
    Array.prototype.forEach.call(searchHits.querySelectorAll('.wp-search-hit'), function(hit){
      var hay = (hit.getAttribute('data-q') || hit.textContent || '').toLowerCase();
      var on = !q || hay.indexOf(q) !== -1;
      hit.style.display = on ? '' : 'none';
      if (on) n++;
    });
    if (searchEmpty) searchEmpty.style.display = n ? 'none' : 'block';
  }
  if (searchInput) searchInput.addEventListener('input', filterSearch);

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { closeNav(); closeSearch(); }
    if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/input|textarea|select/i.test((e.target.tagName || ''))) {
      e.preventDefault();
      openSearch();
    }
  });

  var track = document.getElementById('wpHeroTrack');
  if (track) {
    var slides = track.children;
    var dotsWrap = document.getElementById('wpHeroDots');
    var bar = document.getElementById('wpHeroBar');
    var hero = document.getElementById('wpHero');
    var hi = 0, heroTimer;
    function restartBar(){
      if (!bar) return;
      bar.classList.remove('is-run');
      void bar.offsetWidth;
      bar.classList.add('is-run');
    }
    function goHero(n){
      hi = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-hi * 100) + '%)';
      if (dotsWrap) Array.prototype.forEach.call(dotsWrap.children, function(d, i){ d.classList.toggle('is-on', i === hi); });
      Array.prototype.forEach.call(slides, function(s, i){
        var inner = s.querySelector('.wp-hero-inner');
        if (!inner) return;
        inner.style.animation = 'none';
        if (i === hi) {
          void inner.offsetWidth;
          inner.style.animation = 'wpFadeUp .8s ease both';
        }
      });
      restartBar();
    }
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.className = 'wp-hero-dot' + (i === 0 ? ' is-on' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function(idx){ b.addEventListener('click', function(){ goHero(idx); restartHero(); }); })(i);
        dotsWrap.appendChild(b);
      }
    }
    function restartHero(){
      clearInterval(heroTimer);
      heroTimer = setInterval(function(){ goHero(hi + 1); }, 11000);
      restartBar();
    }
    var prev = root.querySelector('.wp-hero-prev');
    var next = root.querySelector('.wp-hero-next');
    if (prev) prev.addEventListener('click', function(){ goHero(hi - 1); restartHero(); });
    if (next) next.addEventListener('click', function(){ goHero(hi + 1); restartHero(); });
    if (hero) {
      hero.addEventListener('mouseenter', function(){ clearInterval(heroTimer); if (bar) bar.style.animationPlayState = 'paused'; });
      hero.addEventListener('mouseleave', function(){ restartHero(); if (bar) bar.style.animationPlayState = 'running'; });
      var sx = 0;
      hero.addEventListener('touchstart', function(e){ sx = e.changedTouches[0].screenX; }, { passive: true });
      hero.addEventListener('touchend', function(e){
        var dx = e.changedTouches[0].screenX - sx;
        if (Math.abs(dx) > 40) { goHero(hi + (dx < 0 ? 1 : -1)); restartHero(); }
      }, { passive: true });
    }
    restartHero();
  }

  var tabs = root.querySelectorAll('.wp-tab');
  Array.prototype.forEach.call(tabs, function(tab){
    tab.setAttribute('role', 'tab');
    tab.addEventListener('click', function(){
      Array.prototype.forEach.call(tabs, function(t){ t.classList.remove('is-on'); t.setAttribute('aria-selected', 'false'); });
      tab.classList.add('is-on');
      tab.setAttribute('aria-selected', 'true');
      Array.prototype.forEach.call(root.querySelectorAll('.wp-panel'), function(p){ p.classList.remove('is-on'); });
      var panel = document.getElementById('panel-' + tab.getAttribute('data-tab'));
      if (panel) panel.classList.add('is-on');
    });
  });

  var reviews = root.querySelectorAll('#wpReviews .wp-review');
  var rDots = document.getElementById('wpReviewDots');
  var ri = 0;
  function goReview(n){
    if (!reviews.length) return;
    ri = (n + reviews.length) % reviews.length;
    Array.prototype.forEach.call(reviews, function(r, i){ r.style.display = i === ri ? 'grid' : 'none'; });
    if (rDots) Array.prototype.forEach.call(rDots.children, function(d, i){ d.classList.toggle('is-on', i === ri); });
  }
  if (rDots && reviews.length) {
    for (var r = 0; r < reviews.length; r++) {
      var rb = document.createElement('button');
      rb.type = 'button';
      rb.className = r === 0 ? 'is-on' : '';
      (function(idx){ rb.addEventListener('click', function(){ goReview(idx); }); })(r);
      rDots.appendChild(rb);
    }
    if (reviews.length > 1) setInterval(function(){ goReview(ri + 1); }, 7000);
  }

  var priceEl = document.getElementById('wpLivePrice');
  if (priceEl) {
    var opts = root.querySelectorAll('[data-price]');
    function sync(){
      var checked = root.querySelector('[data-price]:checked, select option:checked');
      if (checked) {
        priceEl.textContent = checked.getAttribute('data-price');
        var stickyPrice = document.querySelector('.wp-sticky-atc .price');
        if (stickyPrice) stickyPrice.textContent = checked.getAttribute('data-price');
      }
    }
    Array.prototype.forEach.call(opts, function(o){ o.addEventListener('change', sync); });
    sync();
  }

  Array.prototype.forEach.call(root.querySelectorAll('.wp-stepper'), function(step){
    var input = step.querySelector('input');
    if (!input) return;
    Array.prototype.forEach.call(step.querySelectorAll('button'), function(btn){
      btn.addEventListener('click', function(){
        var dir = parseInt(btn.getAttribute('data-dir'), 10) || 0;
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        var next = Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + dir));
        input.value = next;
      });
    });
  });

  var finder = document.getElementById('wpSystemFinder');
  if (finder) {
    var finderResult = document.getElementById('wpSystemResult');
    var finderLink = document.getElementById('wpSystemLink');
    var finderTitle = document.getElementById('wpSystemTitle');
    var finderCopy = document.getElementById('wpSystemCopy');
    var systems = {
      'well-unit': ['/products/cleanwater-whole-home-water-filter-unit-well-water', 'Well Water Whole Home Unit', 'Entry-point filtration sized for your home.'],
      'municipal-unit': ['/products/ultrasafe-ss', 'Municipal Water Whole Home Unit', 'Entry-point filtration sized for your home.'],
      'well-package': ['/products/cleanwater-whole-home-package-well-water', 'Well Water Whole Home Package', 'Whole Home Unit plus two UnderSink units.'],
      'municipal-package': ['/products/whole-home-package', 'Municipal Water Whole Home Package', 'Whole Home Unit plus two UnderSink units.'],
      'well-living': ['/products/deluxe-whole-home-package-livingwater', 'Well Water LivingWater Package', 'Whole Home Unit, two UnderSink units, and LivingWater.'],
      'municipal-living': ['/products/municipal-water-deluxe-whole-home-package-livingwater-ph-dialing-copy', 'Municipal Water LivingWater Package', 'Whole Home Unit, two UnderSink units, and LivingWater.']
    };
    function updateFinder(){
      var source = finder.querySelector('input[name="water_source"]:checked');
      var system = finder.querySelector('input[name="system_type"]:checked');
      if (!source || !system) {
        if (finderResult) finderResult.hidden = true;
        return;
      }
      var match = systems[source.value + '-' + system.value];
      if (!match) return;
      if (finderTitle) finderTitle.textContent = match[1];
      if (finderCopy) finderCopy.textContent = match[2];
      if (finderLink) finderLink.href = match[0];
      if (finderResult) finderResult.hidden = false;
    }
    Array.prototype.forEach.call(finder.querySelectorAll('input[type="radio"]'), function(input){
      input.addEventListener('change', updateFinder);
    });
    updateFinder();
  }

  var form = document.getElementById('wpCartForm');
  if (form) {
    form.addEventListener('submit', function(e){
      var action = form.getAttribute('action') || '';
      if (!action || action === '#') {
        e.preventDefault();
        toast('Connect this page to Shopify checkout to add items.');
        return;
      }
      if (action.indexOf('/cart/add') !== -1 && window.fetch) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
          .then(function(res){ if (!res.ok) throw new Error('add'); return res.json(); })
          .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
          .then(function(cart){
            Array.prototype.forEach.call(document.querySelectorAll('.wp-cart-pill'), function(pill){
              pill.textContent = 'Cart (' + (cart.item_count || 0) + ')';
            });
            toast('Added to cart');
            if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
          })
          .catch(function(){
            form.submit();
          });
      }
    });
  }

  var sticky = document.getElementById('wpStickyAtc');
  var buy = root.querySelector('.wp-pd-buy');
  if (sticky && buy && 'IntersectionObserver' in window) {
    var sio = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){ sticky.classList.toggle('is-on', !entry.isIntersecting); });
    }, { threshold: 0.08 });
    sio.observe(buy);
    sticky.addEventListener('click', function(e){
      if (e.target.closest('button, a')) {
        var formEl = document.getElementById('wpCartForm');
        if (formEl) formEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  Array.prototype.forEach.call(root.querySelectorAll('.wp-acc-item button'), function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentNode;
      var open = item.classList.contains('is-on');
      Array.prototype.forEach.call(root.querySelectorAll('.wp-acc-item'), function(it){ it.classList.remove('is-on'); });
      if (!open) item.classList.add('is-on');
    });
  });

  var filters = root.querySelectorAll('#wpFilters .wp-filter');
  var cards = root.querySelectorAll('#wpShopGrid .wp-pcard');
  Array.prototype.forEach.call(filters, function(btn){
    btn.addEventListener('click', function(){
      Array.prototype.forEach.call(filters, function(b){ b.classList.remove('is-on'); });
      btn.classList.add('is-on');
      var f = btn.getAttribute('data-filter');
      Array.prototype.forEach.call(cards, function(card){
        var show = f === 'all' || card.getAttribute('data-brand') === f || card.getAttribute('data-cat') === f || card.getAttribute('data-scope') === f;
        card.classList.toggle('is-hidden', !show);
      });
    });
  });

  Array.prototype.forEach.call(root.querySelectorAll('.wp-footer-form form, .wp-form'), function(nf){
    if (nf.id === 'wpCartForm' || nf.getAttribute('action') === '/cart/add') return;
    nf.addEventListener('submit', function(e){
      var act = nf.getAttribute('action') || '';
      if (!act || act === '#') {
        e.preventDefault();
        toast('Thanks — we will be in touch.');
        nf.reset();
      }
    });
  });

  var topBtn = document.getElementById('wpTop');
  if (!topBtn) {
    topBtn = document.createElement('button');
    topBtn.id = 'wpTop';
    topBtn.className = 'wp-top';
    topBtn.type = 'button';
    topBtn.setAttribute('aria-label', 'Back to top');
    topBtn.textContent = '↑';
    document.body.appendChild(topBtn);
  }
  window.addEventListener('scroll', function(){
    topBtn.classList.toggle('is-on', window.scrollY > 600 && !document.querySelector('.wp-sticky-atc.is-on'));
  }, { passive: true });
  topBtn.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: 'smooth' }); });

  var path = (location.pathname || '').replace(/\/$/, '') || '/';
  Array.prototype.forEach.call(root.querySelectorAll('.wp-header-nav a'), function(a){
    var href = (a.getAttribute('href') || '').replace(/\/$/, '');
    if (!href || href === '#') return;
    if (href === path || (href !== '/' && path.indexOf(href) === 0) || (a.pathname && a.pathname.replace(/\/$/, '') === path)) {
      a.style.opacity = '1';
      a.style.textDecoration = 'underline';
      a.style.textUnderlineOffset = '5px';
    }
  });

  var reveal = root.querySelectorAll('.wp-section, .wp-banner, .wp-reviews, .wp-tabbed, .wp-pcard, .wp-icon-block, .wp-cat, .wp-split, .wp-fact, .wp-trust, .wp-how article, .wp-field article, .wp-contact-card');
  Array.prototype.forEach.call(reveal, function(el, idx){
    el.classList.add('wp-reveal');
    if (el.classList.contains('wp-pcard') || el.classList.contains('wp-fact') || el.classList.contains('wp-cat') || el.classList.contains('wp-icon-block') || el.tagName === 'ARTICLE') {
      el.style.transitionDelay = ((idx % 6) * 0.07) + 's';
    }
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    Array.prototype.forEach.call(reveal, function(el){ io.observe(el); });
  } else {
    Array.prototype.forEach.call(reveal, function(el){ el.classList.add('is-in'); });
  }
})();
